<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="#060607"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      fill="#060607"
      clip-rule="evenodd"
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM8 12.1694L14.59 5.57943L16 6.99943L8 14.9994L4 10.9994L5.41 9.58943L8 12.1694Z"
    />
  </svg>
</template>
